// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__92bY6","partOfLogo":"Logo_partOfLogo__V8+PT","whiteLogo":"Logo_whiteLogo__sk1lv","bigSize":"Logo_bigSize__A-nSQ"};